export const ADMIN_ROLE = 'admin'
export const USER_ROLE = 'user'
export const MANAGER_ROLE = 'manager'



// WEBPACK FOOTER //
// ./src/services/AuthService.js